export enum Sort {
  ReceiptDateTimestamp = 'receiptDateTimestamp',
  CmhcOwnerFirstName = 'cmhcOwnerFirstName',
  ApprovedLenderName = 'approvedLenderName',
  DefaultStatus = 'defaultStatus',
}
